<template>
  <v-navigation-drawer
    absolute
    dark
    permanent
    mini-variant-width="100"
    :mini-variant="true"
    stateless
    class="navigation-drawer"
    right
  >
    <v-list>
      <v-tooltip
        left
        v-for="(icon, i) in drawableShapes"
        :key="`drawable-shape-${i}`"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-list-item
            class="mx-auto add-shape-button"
            link
            :ripple="false"
            @click="onShapeClicked(i)"
            v-bind="attrs"
            v-on="on"
          >
            <v-list-item-icon>
              <v-icon
                :color="buttonSelected[i] ? 'orange' : 'white'"
                x-large >
                {{ icon }}
              </v-icon>
            </v-list-item-icon>
          </v-list-item>
        </template>
        <span>{{ buttonNames[i] }}</span>
      </v-tooltip>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import canvasActions from '@/store/modules/canvas/canvasActions'

import { mapState, mapMutations } from 'vuex'
export default {
  name: 'AddShape',

  data: () => ({
    windowHeight: window.innerHeight,
    drawableShapes: [
      'mdi-rectangle-outline',
      'mdi-vector-line',
      'mdi-square-edit-outline',
      'mdi-selection',
      'mdi-content-copy'
    ]
  }),
  methods: {
    ...mapMutations('canvas', ['setCanvasAction']),
    onShapeClicked (i) {
      if (i === 0) {
        this.setCanvasAction((this.canvasAction === canvasActions.AddNode) ? canvasActions.Default : canvasActions.AddNode)
      } else if (i === 1) {
        this.setCanvasAction((this.canvasAction === canvasActions.AddLink) ? canvasActions.Default : canvasActions.AddLink)
      } else if (i === 2) {
        this.setCanvasAction((this.canvasAction === canvasActions.EditNode) ? canvasActions.Default : canvasActions.EditNode)
      } else if (i === 3) {
        this.setCanvasAction((this.canvasAction === canvasActions.SelectNodes) ? canvasActions.Default : canvasActions.SelectNodes)
      } else if (i === 4) {
        this.setCanvasAction((this.canvasAction === canvasActions.CopyNode) ? canvasActions.Default : canvasActions.CopyNode)
      } else {
        console.log('clicked', i)
      }
    }
  },
  computed: {
    ...mapState('canvas', ['canvasAction']),
    buttonSelected: function () {
      return [
        this.canvasAction === canvasActions.AddNode,
        this.canvasAction === canvasActions.AddLink,
        this.canvasAction === canvasActions.EditNode,
        this.canvasAction === canvasActions.SelectNodes,
        this.canvasAction === canvasActions.CopyNode
      ]
    },
    buttonNames: function () {
      return [
        'Add Card',
        'Add Link',
        'Edit Card',
        'Select Cards',
        'Copy Card'
      ]
    }
  }
}
</script>

<style lang="sass" scoped>
  .navigation-drawer
    float: right

  .add-shape-button
    margin: 1em
    text-align: center
</style>
